import type { HyperEntityConfig } from "@shared/backend/hyper-entity.decorator";
import { sanitizePartnerOrgLeadContactChannel } from "@shared/helpers/partner-organization-lead-contact";
import { Roles } from "@shared/Roles";
import { remult } from "remult";
import type { PartnerOrganizationLead } from "./entity";

export const PartnerOrganizationLeadEntityConfig: HyperEntityConfig<PartnerOrganizationLead> =
  {
    allowApiRead: true,
    allowApiCrud: Roles.SuperAdmins,

    apiPrefilterPerRole: (filter) => {
      if (!remult.user) return;

      filter(Roles.SuperDuperAdmin, true);
      filter(Roles.SuperAdmin, true);

      filter([Roles.Admin, Roles.Manager], {
        handlingManagerId: remult.user?.id ?? "",
      });
    },

    allowInsertPerRole(allow) {
      allow(Roles.SuperAdmins, true);
    },

    allowDeleteAndUpdatePerRole(allow) {
      allow(Roles.SuperAdmins, true);
    },

    saving(entity) {
      entity.name = entity.name?.trim() ?? "";
      if (!entity.name) {
        throw new Error("שם הארגון חובה");
      }

      const handlingManagerId = entity.handlingManagerId?.trim() ?? "";
      if (!handlingManagerId) {
        throw new Error("מנהל מלווה חובה");
      }
      entity.handlingManagerId = handlingManagerId;

      const channel = sanitizePartnerOrgLeadContactChannel(entity.contactChannel);
      if (!channel) {
        throw new Error("דרך יצירת קשר חובה");
      }
      entity.contactChannel = channel;

      const phoneNumber = entity.phoneNumber?.trim() ?? "";
      (entity as { phoneNumber: string | null }).phoneNumber = phoneNumber
        ? phoneNumber
        : null;

      const email = entity.email?.trim() ?? "";
      if (channel === "EMAIL" && !email) {
        throw new Error("מייל חובה כשדרך יצירת הקשר היא מייל");
      }
      (entity as { email: string | null }).email = email || null;

      const contactRole = entity.contactRole?.trim() ?? "";
      (entity as { contactRole: string | null }).contactRole = contactRole || null;

      const notes = entity.notes?.trim() ?? "";
      (entity as { notes: string | null }).notes = notes || null;

      const partnerOrganizationId = entity.partnerOrganizationId;
      if (!partnerOrganizationId || !String(partnerOrganizationId).trim()) {
        (entity as { partnerOrganizationId: string | null }).partnerOrganizationId =
          null;
      }
    },
  };
